<template>
  <div class="card delete-account">
    <h3 class="delete-account__title">
      Delete account
    </h3>

    <p class="delete-account__description">
      Once you delete your account, there is no going back. Please be certain.
    </p>

    <el-button type="danger" plain @click="isConfirmationDialogVisible = true">
      Delete my accout
    </el-button>

    <el-dialog
      v-model="isConfirmationDialogVisible"
      width="30%"
      title="Delete account"
    >
      <span>
        Are you sure you want to delete your account? It cannot be restore.
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isConfirmationDialogVisible = false">
          Cancel
        </el-button>
        <el-button
          type="danger"
          @click="requestDeleteAccount"
          :disabled="isButtonDisabled('delete-account')"
        >
          Delete
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { deleteAccount } from '@/api/user.js';
import { AUTH_LOGOUT } from '@/store/mutationTypes.js';
import { showMessage } from '@/utils/messages.js';
import { disableButton } from '@/mixins/disableButton.js';

export default {
  name: 'DeleteAccount',
  mixins: [disableButton],
  data() {
    return {
      isConfirmationDialogVisible: false,
    };
  },
  methods: {
    showMessage,
    async requestDeleteAccount() {
      this.disableButton('delete-account');
      const { data, success } = await deleteAccount();
      this.enableButton('delete-account');

      if (success) {
        this.$store.commit(AUTH_LOGOUT);
        this.showMessage({
          type: 'success',
          message: 'Your account has been removed',
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/shared/_globals.scss';

.delete-account {
  &__title {
    margin: 0.5em 0;
    font-size: 24px;
    font-weight: 500;
    color: var(--color-danger-400);
  }
  &__description {
    margin-bottom: 1.5em;
    font-size: 16px;
  }
}
</style>
